import axios from 'axios';
import { config } from 'config/config';
const bookingAxiosApi = axios.create({
  baseURL: config.BACKEND_API_BASE_URL,
  headers: {
    'x-api-key': config.GATEWAY_API_KEY,
    'Content-Type': 'application/json',
  },
});

// Optional: add token interceptor
// branchAxiosaApi.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

export default bookingAxiosApi;
